
export const WhatsIncluded = () => {
  return (
    <section>
      <h2 className="text-[62px] font-medium mb-8">Service Options</h2>
      
      <div className="space-y-12">
        <div>
          <h3 className="text-[32px] font-medium mb-4">Single Strategy Session (250€)</h3>
          <ul className="list-disc pl-6 space-y-4 text-[22px] font-inter">
            <li>60-minute focused consultation</li>
            <li>Deep-dive into 1-2 key challenges</li>
            <li>Collaborative action plan</li>
            <li>Session recording and notes</li>
            <li>Follow-up check-in via text or email</li>
          </ul>
        </div>

        <div>
          <h3 className="text-[32px] font-medium mb-4">Quarterly Strategic Partnership (2800€)</h3>
          <ul className="list-disc pl-6 space-y-4 text-[22px] font-inter">
            <li>Unlimited 60-minute strategy sessions</li>
            <li>Priority scheduling</li>
            <li>Regular check-ins via text or email to ensure progress</li>
            <li>Ongoing thought partnership</li>
          </ul>
          <p className="text-[22px] mt-6 italic font-inter">Optional: Custom AI prompts and workflows to build your strategic "second brain"</p>
        </div>

        <div>
          <h3 className="text-[32px] font-medium mb-4">How We'll Work Together</h3>
          <ol className="list-decimal pl-6 space-y-4 text-[22px] font-inter">
            <li><span className="font-medium">Discovery Call (15 mins):</span> Brief introduction and alignment on objectives</li>
            <li><span className="font-medium">Session Scheduling:</span> Book your first session with 48h notice</li>
            <li><span className="font-medium">Strategy Session:</span> Focused discussion and action planning</li>
            <li><span className="font-medium">Implementation:</span> Execute with clear direction</li>
            <li><span className="font-medium">Follow-up:</span> Quick text or email check-ins to keep momentum</li>
          </ol>
        </div>
      </div>
    </section>
  );
};
